import React from "react"

function IconCheckmark({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="checkmark"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-checkmark"
      {...props}
    >
      <path
        d="M17.723 7.202a.655.655 0 0 1 1.05.773l-.07.096-7.736 8.727a.655.655 0 0 1-.892.082l-.084-.078-3.932-4.363a.655.655 0 0 1 .886-.957l.087.08 3.442 3.819 7.249-8.179z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconCheckmark
